import { render, staticRenderFns } from "./LoadingMessage.vue?vue&type=template&id=a5c8a082&scoped=true"
import script from "./LoadingMessage.vue?vue&type=script&lang=js"
export * from "./LoadingMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c8a082",
  null
  
)

export default component.exports